import { render } from "./TDBG_SRLQ.vue?vue&type=template&id=c7534b8e&scoped=true"
import script from "./TDBG_SRLQ.vue?vue&type=script&lang=js"
export * from "./TDBG_SRLQ.vue?vue&type=script&lang=js"

import "./TDBG_SRLQ.vue?vue&type=style&index=0&id=c7534b8e&lang=css"
import "./TDBG_SRLQ.vue?vue&type=style&index=1&id=c7534b8e&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7534b8e"]])

export default __exports__